import { Link } from 'react-router-dom';

const trustChecks = ['Simple', 'Automatique', "Pensé pour l'IDEL"];

export default function HeroSection() {
  return (
    <section className="relative w-full overflow-hidden bg-background-50">
      {/* Halos décoratifs */}
      <div className="pointer-events-none absolute -top-32 -right-24 w-[560px] h-[560px] rounded-full bg-primary-100/60 blur-3xl"></div>
      <div className="pointer-events-none absolute -bottom-24 -left-32 w-[460px] h-[460px] rounded-full bg-accent-100/50 blur-3xl"></div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-6 pt-20 pb-20 md:pt-28 md:pb-28 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-8 animate-on-scroll">
          <span className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-pulse"></span>
          L&apos;intelligence de cotation des IDEL
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold font-heading text-foreground-950 leading-[1.05] mb-6 animate-on-scroll">
          Vous soignez.
          <br />
          CotIdel cote.
        </h1>

        <p className="text-base md:text-xl text-foreground-600 max-w-xl mx-auto mb-10 animate-on-scroll">
          Décrivez les soins. CotIdel cote juste.
        </p>

        <Link
          to="/app"
          className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-bold px-10 py-4 rounded-md text-base transition-all duration-200 cursor-pointer whitespace-nowrap animate-on-scroll"
        >
          <i className="ri-rocket-2-line text-lg"></i>
          COTER UN SOIN
        </Link>

        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 mt-8 text-sm text-foreground-600 animate-on-scroll">
          {trustChecks.map((item) => (
            <span key={item} className="flex items-center gap-1.5">
              <i className="ri-check-line text-primary-600"></i>
              {item}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}